import * as types from "./types";

const INITIAL_STATE = {
  company: null,
  loading: false,
  error: null,
};

const companyMyCompany = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case types.GET_MY_COMPANY_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };

    case types.GET_MY_COMPANY_SUCCESS:
      return {
        ...state,
        loading: false,
        company: action.payload,
      };

    case types.GET_MY_COMPANY_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload?.error || null,
      };

    case types.CLEAR_MY_COMPANY:
      return INITIAL_STATE;

    case types.CLEAR_MY_COMPANY_ACTIVE_EDIT_REQUEST:
      if (!state.company || typeof state.company !== "object") return state;
      return {
        ...state,
        company: {
          ...state.company,
          company_edit_request: null,
        },
      };

    default:
      return state;
  }
};

export default companyMyCompany;
